import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import SearchCom from "./SearchCom";
import { useSnackbar } from "notistack";
import ProgressCom from "../../components/ProgressCom";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DetailsGrid from "./DetailsGrid";
import { UseAddOrder } from "./UseAddOrder";
import UserDetail from "./UserDetail";
import SetOrderDetails from "./SetOrderDetails";
import { useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import useBreakpoints from "../../hooks/useBreakpoints";
import AddOrderDetail from "./AddOrderDetail";

export default function AddOrder() {
  const [expanded, setExpanded] = useState("panel1");
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { AddToOrder, getByOrderID } = UseAddOrder();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialoge, setOpenDialoge] = useState(false);
  const [sendP, setSendP] = useState(false);
  const location = useLocation();
  const [orderRes, setOrderRes] = useState();
  const [productID, setProductID] = useState(undefined);
  const [paymentDet, setPaymentDet] = useState();
  const [productModel, setProductModel] = useState({
    productID: undefined,
    orderCount: "",
  });
  const orderCTF = useRef(null);
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    orderID: orderRes && orderRes.orderID,
    address: undefined,
    cityID: undefined,
    description: undefined,
    firstName: undefined,
    lastName: undefined,
    mobile: undefined,
    postCode: undefined,
    provinceID: undefined,
    neighbourhoodID: undefined,
    deliveryID: undefined,
    deliveryType: undefined,
    phone: undefined,
    paymentType: undefined,
    // bankID: null,
    offlinePayCode: null,
    SendFactor: false,
    Confidential: false,
    SendSMS: false,
    notUsecraditDiscount: false,
  });

  const [errorState, setErrorState] = useState({
    address: false,
    cityID: false,
    firstName: false,
    lastName: false,
    mobile: false,
    provinceID: false,
    deliveryID: false,
    deliveryType: false,
    phone: false,
    paymentType: false,
  });

  useEffect(() => {
    if (productID !== undefined) {
      setProductModel({
        productID: productID.id,
        orderCount: productID.storeCount > 0 ? 1 : 0,
      });
    }
  }, [productID]);

  useEffect(() => {
    if (location.state && location.state.OrderId) {
      getByOrderID(location.state.OrderId, (callback) => {
        setState({
          ...state,
          orderID: callback.id,
          address: callback.address,
          cityID: callback.cityID,
          description: callback.description,
          firstName: callback.firstName,
          lastName: callback.lastName,
          mobile: callback.mobile,
          postCode: callback.postCode,
          provinceID: callback.provinceID,
          neighbourhoodID: callback.neighbourhoodID,
          phone: callback.phone,
        });
        setOrderRes({
          ...orderRes,
          orderID: callback.order.orderID,
          totalCost: callback.order.totalCost,
          deliveryCost: callback.order.deliveryCost,
          creditDiscount: callback.order.creditDiscount,
          codeDiscount: callback.order.codeDiscount,
          totalPayCost: callback.order.totalPayCost,
          products: callback.order.products,
        });
      });
      return;
    } else {
      getByOrderID(0, (callback) => {});
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        addOrderButton: {
          setState: setState,
          setOrderRes: setOrderRes,
          setExpanded: setExpanded,
        },
        title: "سفارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/ordermodify" }],
      }}
    >
      <YesOrNoDialoge
        addOrder
        setCheckState={setCheckState}
        checkState={checkState}
        callback={() => {
          let body = {
            OrderId: orderRes ? orderRes.orderID : 0,
            Productid: productID.id,
            Count: productModel.orderCount,
          };
          setProgress(true);
          AddToOrder(body, (callback) => {
            setExpanded("panel1");
            setProgress(false);
            setSendP(true);
            setOrderRes(callback);
            setState({ ...state, orderID: callback.orderID });
            setProductID(undefined);
            setProductModel({ ...productModel, orderCount: "" });
          });
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          alignItems="center"
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={1}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: isSmall ? "flex-start" : "center",
              flexDirection: isSmall ? "column" : "row",
              gap: 2,
            }}
            gridColumn="span 12"
          >
            <Typography sx={{ width: "100px" }} variant="subtitle2">
              محصول :
            </Typography>
            <SearchCom
              fullwidth={isSmall ? true : false}
              notText={true}
              productID={productID}
              productModel={productModel}
              setSelectedProduct={setProductID}
              setProductModel={setProductModel}
            ></SearchCom>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <TextField
                value={productID ? productID.storeCount : ""}
                sx={{
                  ml: !isSmall && 2,
                  input: { textAlign: "center", cursor: "default" },
                }}
                label="موجودی"
                variant="filled"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  autoComplete: "off",
                  inputProps: {
                    min: 1,
                  },
                }}
              />
            </Box>
            <TextField
              value={productID ? productModel.orderCount : ""}
              onKeyDown={(e) =>
                exceptThisSymbols.includes(e.key) && e.preventDefault()
              }
              onChange={(evt) => {
                setProductModel({
                  ...productModel,
                  orderCount: evt.target.value,
                  productID: productID && productID.id,
                });
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "100%",
                },
                height: "100%",
                input: {
                  height: "100%",
                },
                mx: !isSmall && 2,
              }}
              type="number"
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
              }}
              inputRef={orderCTF}
              label="تعداد درخواست"
              variant="outlined"
            />
            <Button
              sx={{ width: "120px" }}
              variant="contained"
              onClick={() => {
                if (
                  (productModel.orderCount !== 0 &&
                    productModel.orderCount !== 0 &&
                    !productModel.orderCount) ||
                  !productModel.productID
                ) {
                  enqueueSnackbar("لطفا محصول و تعداد درخواست را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                } else if (productModel.orderCount > productID.storeCount) {
                  setCheckState({
                    show: true,
                    name: "تعداد درخواستی شما از موجودی محصول فوق بیشتر می باشد،آیا مایل به افزایش موجودی اتوماتیک محصول هستید؟",
                  });
                  return;
                } else if (productModel.orderCount == 0) {
                  setProductModel({ ...productModel, orderCount: "" });
                  enqueueSnackbar("تعداد درخواستی نامعتبر است", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                } else {
                  let body = {
                    OrderId: orderRes ? orderRes.orderID : 0,
                    Productid: productID.id,
                    Count: productModel.orderCount,
                  };
                  setProgress(true);
                  AddToOrder(body, (callback) => {
                    setExpanded("panel1");
                    setProgress(false);
                    setSendP(true);
                    setOrderRes(callback);
                    setState({ ...state, orderID: callback.orderID });
                    setProductID(undefined);
                    setProductModel({ ...productModel, orderCount: "" });
                  });
                }
              }}
            >
              افزودن
            </Button>
          </Box>
        </Box>
        <Box
          sx={{ mt: 3 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={2}
        >
          <Box gridColumn="span 12">
            <DetailsGrid
              state={state}
              setState={setState}
              orderID={orderRes && orderRes.orderID}
              row={orderRes}
              setExpanded={setExpanded}
              setRow={setOrderRes}
            />
          </Box>
        </Box>
        <Accordion
          expanded={expanded === "panel2"}
          style={{ boxShadow: 3, paddingBottom: "15px" }}
        >
          <AccordionSummary
            onClick={() => {
              if (orderRes && orderRes.orderID) {
                setExpanded("panel2");
              } else {
                enqueueSnackbar("محصولات سفارش را وارد کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
            }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography variant="subtitle1" color="secondary">
              ثبت اطلاعات
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{ mt: 3 }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={2}
            >
              <Box gridColumn={isSmall ? "span 12" : "span 9"}>
                <AddOrderDetail
                  state={state}
                  setState={setState}
                  orderID={orderRes && orderRes.orderID}
                  row={orderRes && orderRes}
                  setRow={setOrderRes}
                  errorState={errorState}
                  setErrorState={setErrorState}
                  expanded={expanded}
                />
              </Box>
              <Box gridColumn={isSmall ? "span 12" : "span 3"}>
                <SetOrderDetails
                  paymentDet={paymentDet}
                  state={state}
                  setState={setState}
                  orderID={orderRes && orderRes.orderID}
                  row={orderRes}
                  setRow={setOrderRes}
                  errorState={errorState}
                  setExpanded={setExpanded}
                  setErrorState={setErrorState}
                />
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        {progress ? <ProgressCom /> : ""}
      </Box>
    </Detail>
  );
}
